import { useWindowDimensions } from 'react-native';

const BREAKPOINTS = {
  base: 0,
  xs: 400,
  sm: 480,
  md: 768,
  lg: 992,
  xl: 1280,
} as const;

type BreakpointKey = keyof typeof BREAKPOINTS;
type BreakpointValues = Partial<Record<BreakpointKey, any>>;

export function useBreakpointValueGS(values: BreakpointValues) {
  const { width } = useWindowDimensions();

  const ordered = Object.entries(BREAKPOINTS) as [BreakpointKey, number][];

  let lastValue: any | undefined;

  for (const [key, minWidth] of ordered) {
    if (width >= minWidth) {
      if (key in values) {
        lastValue = values[key];
      }
    } else {
      break;
    }
  }

  return lastValue;
}
